import { SearchParam } from './searchParam.model';

export class SearchGlobalParam {
    constructor(_PageSize?: number, _ColumnSelected?:string[], _ColumnOrderBy?: string, _request?: SearchParam[]) {
        this.PageSize = _PageSize;
        this.ColumnSelected = _ColumnSelected;
        this.ColumnOrderBy = _ColumnOrderBy;
        this.request = _request;
    }

    public PageSize: number | null;
    public ColumnSelected: string[] | null;
    public ColumnOrderBy: string | null;
    public request: SearchParam[] | null;
  }
